export default __webpack_public_path__ + "static/media/Rubik-Bold.366b50ff.ttf";